export function IpGuideMacos() {
  return (
    <div className="space-y-6">
      {/* Step 1 */}
      <div className="flex gap-3">
        <span className="shrink-0 w-6 h-6 rounded-full bg-blue-600 text-white text-xs font-bold flex items-center justify-center mt-0.5">
          1
        </span>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-gray-700 mb-3">
            Oben rechts auf das <strong>WLAN-Symbol</strong> in der Menüleiste klicken.
          </p>
          <svg viewBox="0 0 300 90" xmlns="http://www.w3.org/2000/svg" className="w-full max-w-sm mx-auto block rounded-lg" aria-hidden="true">
            {/* Desktop bg – macOS Sonoma style */}
            <defs>
              <linearGradient id="macDesk" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#1a4a8a" />
                <stop offset="100%" stopColor="#4a90d9" />
              </linearGradient>
            </defs>
            <rect width="300" height="90" fill="url(#macDesk)" />
            {/* Menu bar */}
            <rect width="300" height="24" fill="rgba(255,255,255,0.82)" />
            {/* Apple logo */}
            <text x="12" y="17" fontSize="14" fill="#000">⌘</text>
            <text x="30" y="16" fontSize="11" fill="#000" fontWeight="500">Finder</text>
            <text x="74" y="16" fontSize="11" fill="#000">Ablage</text>
            <text x="112" y="16" fontSize="11" fill="#000">Bearbeiten</text>
            {/* Right side: battery, wifi, time */}
            <text x="224" y="16" fontSize="10" fill="#000">100%</text>
            {/* WiFi icon – highlighted with subtle blue */}
            <rect x="252" y="4" width="22" height="16" rx="4" fill="rgba(0,122,255,0.15)" />
            <text x="263" y="16" textAnchor="middle" fontSize="13" fill="#000">◈</text>
            <text x="279" y="16" fontSize="11" fill="#000">🔔</text>
            {/* Arrow pointing up to wifi icon */}
            <polygon points="263,24 257,36 269,36" fill="#ff9500" />
            {/* Tooltip */}
            <rect x="231" y="38" width="64" height="14" rx="4" fill="rgba(0,0,0,0.65)" />
            <text x="263" y="49" textAnchor="middle" fontSize="8.5" fill="#fff">hier klicken</text>
          </svg>
        </div>
      </div>

      {/* Step 2 */}
      <div className="flex gap-3">
        <span className="shrink-0 w-6 h-6 rounded-full bg-blue-600 text-white text-xs font-bold flex items-center justify-center mt-0.5">
          2
        </span>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-gray-700 mb-3">
            Neben dem verbundenen Netzwerk auf <strong>„Details"</strong> klicken.
          </p>
          <svg viewBox="0 0 220 240" xmlns="http://www.w3.org/2000/svg" className="w-full max-w-[210px] mx-auto block rounded-lg" aria-hidden="true">
            {/* Menu bar sliver */}
            <rect width="220" height="24" fill="rgba(255,255,255,0.85)" />
            <rect x="166" y="4" width="22" height="16" rx="4" fill="rgba(0,122,255,0.15)" />
            <text x="177" y="16" textAnchor="middle" fontSize="13" fill="#000">◈</text>
            {/* Dropdown panel */}
            <rect x="8" y="24" width="204" height="210" rx="12" fill="#ffffff" stroke="rgba(0,0,0,0.1)" strokeWidth="1" filter="drop-shadow(0 4px 16px rgba(0,0,0,0.18))" />
            {/* Title */}
            <text x="110" y="48" textAnchor="middle" fontSize="12" fontWeight="600" fill="#000">WLAN</text>
            <line x1="16" y1="56" x2="204" y2="56" stroke="#f0f0f0" strokeWidth="1" />
            {/* Connected network row */}
            <rect x="14" y="60" width="192" height="46" rx="8" fill="#f0f6ff" />
            {/* Signal bars */}
            <rect x="22" y="78" width="3" height="6" rx="1.5" fill="#1a73e8" />
            <rect x="27" y="74" width="3" height="10" rx="1.5" fill="#1a73e8" />
            <rect x="32" y="69" width="3" height="15" rx="1.5" fill="#1a73e8" />
            <text x="42" y="78" fontSize="12" fill="#000" fontWeight="600">ALB-WLAN</text>
            <text x="42" y="92" fontSize="10" fill="#5f6368">Verbunden</text>
            {/* Details button */}
            <rect x="152" y="70" width="46" height="22" rx="6" fill="#0071e3" />
            <text x="175" y="85" textAnchor="middle" fontSize="10.5" fill="#fff" fontWeight="500">Details</text>
            <line x1="16" y1="110" x2="204" y2="110" stroke="#f0f0f0" strokeWidth="1" />
            {/* Other networks */}
            <rect x="14" y="114" width="192" height="36" rx="6" fill="transparent" />
            <rect x="22" y="124" width="3" height="5" rx="1" fill="#aaa" />
            <rect x="27" y="121" width="3" height="8" rx="1" fill="#bbb" />
            <rect x="32" y="117" width="3" height="12" rx="1" fill="#ccc" />
            <text x="42" y="134" fontSize="11.5" fill="#888">Heimnetz-5G</text>
            <line x1="16" y1="154" x2="204" y2="154" stroke="#f0f0f0" strokeWidth="1" />
            <rect x="14" y="158" width="192" height="36" rx="6" fill="transparent" />
            <rect x="22" y="168" width="3" height="4" rx="1" fill="#999" />
            <rect x="27" y="165" width="3" height="7" rx="1" fill="#aaa" />
            <rect x="32" y="161" width="3" height="11" rx="1" fill="#bbb" />
            <text x="42" y="178" fontSize="11.5" fill="#888">Gäste-WLAN</text>
            <line x1="16" y1="198" x2="204" y2="198" stroke="#f0f0f0" strokeWidth="1" />
            {/* Settings link */}
            <text x="110" y="220" textAnchor="middle" fontSize="11" fill="#0071e3">WLAN-Einstellungen…</text>
          </svg>
        </div>
      </div>

      {/* Step 3 */}
      <div className="flex gap-3">
        <span className="shrink-0 w-6 h-6 rounded-full bg-blue-600 text-white text-xs font-bold flex items-center justify-center mt-0.5">
          3
        </span>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-gray-700 mb-3">
            Im Reiter <strong>„TCP/IP"</strong> steht deine <strong>IPv4-Adresse</strong>.
          </p>
          <svg viewBox="0 0 300 200" xmlns="http://www.w3.org/2000/svg" className="w-full max-w-sm mx-auto block rounded-lg" aria-hidden="true">
            {/* Window frame */}
            <rect width="300" height="200" rx="12" fill="#ececec" stroke="#c8c8c8" strokeWidth="0.8" />
            {/* Title bar – macOS style */}
            <rect width="300" height="30" rx="12" fill="#d8d8d8" />
            <rect x="0" y="15" width="300" height="15" fill="#d8d8d8" />
            {/* macOS traffic lights (LEFT side – correct!) */}
            <circle cx="16" cy="15" r="6.5" fill="#ff5f57" />
            <circle cx="33" cy="15" r="6.5" fill="#febc2e" />
            <circle cx="50" cy="15" r="6.5" fill="#28c840" />
            {/* Subtle ✕ ─ + icons on hover circles */}
            <text x="16" y="18.5" textAnchor="middle" fontSize="6.5" fill="rgba(0,0,0,0.35)">✕</text>
            <text x="33" y="18.5" textAnchor="middle" fontSize="6.5" fill="rgba(0,0,0,0.25)">─</text>
            <text x="50" y="18.5" textAnchor="middle" fontSize="6.5" fill="rgba(0,0,0,0.25)">⊕</text>
            <text x="150" y="19" textAnchor="middle" fontSize="11" fontWeight="500" fill="#444">ALB-WLAN – Details</text>
            {/* Tabs */}
            <rect x="0" y="30" width="300" height="22" fill="#e0e0e0" />
            <rect x="8" y="34" width="52" height="16" rx="4" fill="#fff" stroke="#c0c0c0" strokeWidth="0.5" />
            <text x="34" y="45.5" textAnchor="middle" fontSize="10.5" fontWeight="600" fill="#000">TCP/IP</text>
            <text x="80" y="45" fontSize="10.5" fill="#666">DNS</text>
            <text x="106" y="45" fontSize="10.5" fill="#666">WINS</text>
            <text x="134" y="45" fontSize="10.5" fill="#666">802.1X</text>
            {/* Content area */}
            <rect x="0" y="52" width="300" height="148" fill="#fff" />
            <text x="18" y="74" fontSize="10.5" fill="#666">IPv4-Konfiguration:</text>
            <text x="155" y="74" fontSize="10.5" fill="#333">Automatisch (DHCP)</text>
            <line x1="10" y1="82" x2="290" y2="82" stroke="#f0f0f0" strokeWidth="0.8" />
            {/* IPv4 row – red border highlight */}
            <rect x="8" y="84" width="284" height="24" rx="4" fill="rgba(239,68,68,0.06)" />
            <rect x="8" y="84" width="284" height="24" rx="4" fill="none" stroke="#ef4444" strokeWidth="1.8" />
            <text x="18" y="100" fontSize="10.5" fill="#c0392b" fontWeight="500">IPv4-Adresse:</text>
            <text x="215" y="100" fontSize="12" fontWeight="700" fill="#c0392b">192.168.1.42</text>
            <polygon points="292,96 300,91 300,101" fill="#ef4444" />
            <line x1="10" y1="110" x2="290" y2="110" stroke="#f0f0f0" strokeWidth="0.8" />
            <text x="18" y="126" fontSize="10.5" fill="#666">Subnetzmaske:</text>
            <text x="155" y="126" fontSize="10.5" fill="#333">255.255.255.0</text>
            <line x1="10" y1="134" x2="290" y2="134" stroke="#f0f0f0" strokeWidth="0.8" />
            <text x="18" y="150" fontSize="10.5" fill="#666">Router:</text>
            <text x="155" y="150" fontSize="10.5" fill="#333">192.168.1.1</text>
            <line x1="10" y1="158" x2="290" y2="158" stroke="#f0f0f0" strokeWidth="0.8" />
            <text x="18" y="174" fontSize="10.5" fill="#666">DNS-Server:</text>
            <text x="155" y="174" fontSize="10.5" fill="#aaa">192.168.1.1</text>
          </svg>
        </div>
      </div>
    </div>
  );
}
